import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { GhostBtn, Spinner, readTheme } from '../../components/studio/studioUi';
import { useToast } from '../../components/common/Toast';
import { errorText } from '../../services/video.service';
import { PLATFORM_LABEL, socialService } from '../../services/social.service';
import { FONT_SANS, FONT_SERIF } from '../landing/landingData';

/**
 * /video/connect/:provider — where the platform sends the browser back. The code
 * is exchanged by core-api with this user's session (it checks the state belongs
 * to them), then we return to the schedule page.
 */
export const SocialConnectCallback: React.FC = () => {
    const { provider = '' } = useParams();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const toast = useToast();
    const [error, setError] = useState('');
    const sent = useRef(false);

    useEffect(() => {
        if (sent.current) return;
        sent.current = true;
        // LinkedIn sends error_description HTML-escaped (&quot;openid&quot;).
        const denied = decodeEntities(params.get('error_description') || params.get('error') || '');
        const code = params.get('code') || '';
        const state = params.get('state') || '';
        if (denied || !code) {
            setError(denied ? `Izin tidak diberikan (${denied}).` : 'Izin tidak diberikan.');
            return;
        }
        socialService
            .finishConnect(provider, code, state)
            .then((r) => {
                toast.success(`Terhubung: ${r.connected.map((c) => `${c.name} (${PLATFORM_LABEL[c.platform]})`).join(', ')}`);
                navigate('/video/schedule', { replace: true });
            })
            .catch((e) => setError(errorText(e, 'Gagal menghubungkan akun.')));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="hv-root" data-hv-theme={readTheme()} style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--hv-desk)', fontFamily: FONT_SANS, color: 'var(--hv-ink)', padding: 24 }}>
            {error ? (
                <div style={{ textAlign: 'center', maxWidth: 460 }}>
                    <div style={{ fontFamily: FONT_SERIF, fontSize: 30 }}>Akun belum terhubung</div>
                    <p style={{ color: 'var(--hv-muted)' }}>{error}</p>
                    <GhostBtn onClick={() => navigate('/video/schedule', { replace: true })}>Kembali</GhostBtn>
                </div>
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, color: 'var(--hv-body)' }}><Spinner /> Menghubungkan akun…</div>
            )}
        </div>
    );
};

/** Text of an HTML-escaped string, without ever parsing it as markup. */
function decodeEntities(s: string): string {
    return new DOMParser().parseFromString(`<!doctype html><textarea>${s.replace(/</g, '&lt;')}</textarea>`, 'text/html').querySelector('textarea')?.value ?? s;
}
